<template>
  <ContentWrapperControl>
    <div>
      <BalanceGroupControl :dropdown="false">
        <BalanceDisplayControl
          v-for="savings in getSavingsTypes"
          :key="savings.code"
          :title="savings.name"
          :balance="getBalancesByCode(savings.code)"
          :as_of="getAsOfByCode(savings.code)"
          :show_default="false"
          :clickable="true"
          :href="`/balance/transactions/${savings.code}`"
        />
      </BalanceGroupControl>
      <BalanceGroupControl
        title="Shares"
        :icon="require('@/assets/icons/papsi_shares.svg')"
        text_color="audit"
        circle_color="audit-light"
        :dropdown="false"
      >
        <BalanceDisplayControl
          v-for="shares in getShares"
          :key="shares.code"
          :title="shares.name"
          text_color="audit"
          :balance="getBalancesByCode(shares.code)"
          :as_of="getAsOfByCode(shares.code)"
          :clickable="true"
          :href="`/balance/transactions/${shares.code}`"
          :show_default="false"
        />
      </BalanceGroupControl>
      <BalanceGroupControl
        title="Loans"
        :icon="require('@/assets/icons/papsi_loans.svg')"
        text_color="secondary-dark"
        circle_color="secondary-light"
        :dropdown="false"
      >
        <BalanceDisplayControl
          v-for="loans in getLoansTypes"
          :key="loans.code"
          :title="loans.name"
          :text_color="
            getRecordsByCode(loans.code) == 0 ? 'grey' : 'secondary-dark'
          "
          :balance="getBalancesByCode(loans.code)"
          :as_of="getAsOfByCode(loans.code)"
          :disabled="getRecordsByCode(loans.code) == 0"
          :show_default="false"
          :clickable="getRecordsByCode(loans.code) > 0"
          :href="`/balance/transactions/${loans.code}`"
        />
      </BalanceGroupControl>
    </div>
  </ContentWrapperControl>
</template>

<script>
import ContentWrapperControl from "@/components/controls/ContentWrapperControl.vue";
import BalanceDisplayControl from "@/components/controls/BalanceDisplayControl.vue";
import BalanceGroupControl from "@/components/controls/BalanceGroupControl.vue";
import mixin from "@/mixin";

export default {
  mixins: [mixin],

  components: {
    ContentWrapperControl,
    BalanceDisplayControl,
    BalanceGroupControl,
  },

  data() {
    return {};
  },

  mounted() {
    // this.$emit("showloader");
    this.$emit("checkauth", true);
    this.$emit("nofooter", false);

    this.$emit("shownavbar", {
      title: this.lang("lbl_0000486"),
      show: true,
      back: true,
    });

    // let state = this.$store.state;
  },

  computed: {
    getSavingsTypes() {
      return this.$store.state.ledgers.types
        .filter((item) => !item.is_loan && item.code !== "SHR")
        .sort((a, b) => a.name.localeCompare(b.name));
    },
    getLoansTypes() {
      const loans = this.$store.state.ledgers.types
        .filter((item) => item.is_loan && item.code !== "SHR")
        .map((item) => {
          const balance = this.getBalancesByCode(item.code);
          const records = this.getRecordsByCode(item.code);

          return {
            ...item,
            balance,
            records,
          };
        });

      const ongoing_loans = loans
        .filter((l) => l.balance > 0)
        .sort((a, b) => b.balance - a.balance);

      const completed_loans = loans
        .filter((l) => l.balance <= 0 && l.records > 0)
        .sort((a, b) => a.name.localeCompare(b.name));

      const no_records = loans
        .filter((l) => l.records === 0)
        .sort((a, b) => a.name.localeCompare(b.name));

      return [...ongoing_loans, ...completed_loans, ...no_records];
    },
    getShares() {
      return this.$store.state.ledgers.types
        .filter((item) => item.code == "SHR")
        .sort((a, b) => a.name.localeCompare(b.name));
    },
  },
  methods: {
    getBalancesByCode(code) {
      const item = this.$store.state.ledgers.balances.find(
        (item) => item.code === code,
      );
      return item ? item.total_balance : 0;
    },
    getRecordsByCode(code) {
      const item = this.$store.state.ledgers.balances.find(
        (item) => item.code === code,
      );
      return item ? item.total_records : 0;
    },
    getAsOfByCode(code) {
      const today = new Date();

      const month = String(today.getMonth() + 1).padStart(2, "0");
      const day = String(today.getDate()).padStart(2, "0");
      const year = today.getFullYear();

      const item = this.$store.state.ledgers.balances.find(
        (item) => item.code === code,
      );
      return item ? item.as_of : `${month}/${day}/${year}`;
    },
  },
};
</script>

<style scoped></style>
